class NetworkError extends Error {
  constructor(statusCode, key, message, ...args) {
    super(...args);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NetworkError);
    } else {
      this.stack = new Error().stack;
    }

    // HTTP Status Code
    this.statusCode = statusCode;
    // Locize translation key
    this.key = key;
    // HTTP response message
    this.message = message;
  }
}

export default NetworkError;
